// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "h3[id='not-found'], h2[id='return-home'] {\n  text-align: center;\n  font-weight: 700;\n  line-height: 50px;\n}", "",{"version":3,"sources":["noMatchPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","file":"noMatchPage.css","sourcesContent":["h3[id='not-found'], h2[id='return-home'] {\n  text-align: center;\n  font-weight: 700;\n  line-height: 50px;\n}"]}]);
// Exports
module.exports = exports;
